// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8ffddbe3","155":"8ee73d9f","223":"3288f4ab","453":"474266d1","953":"d811dc26","995":"9e1e5914"}[chunkId] + ".chunk.js";
};